import React from 'react';
import Head from 'next/head';

export const Header = ({ title }) => {
  return (
    <>
      <Head>
        <title>{`Yepic Plus | ${title}`}</title>
      </Head>
    </>
  );
};
